<app-top-nav></app-top-nav>
<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="page-title">Templates</div>
        <div class="header-actions" *ngIf="canWrite">
          <div class="checkbox">
            <p-checkbox class="checkbox-field" [(ngModel)]="showAllData" [binary]="true" (onChange)="onChangeCheckMark()" inputId="allData"></p-checkbox>
            <label class="checkbox-label" for="allData"> Show All Data</label>
          </div>
          <p-button class="button-field" routerLink="create">Add template</p-button>
        </div>
      </div>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [columns]="cols"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{ sort.direction == 1 ? 'sort-ascending' : 'sort-descending'}}"
                        *ngIf="sort.direction"
                      >
                        straight
                      </mat-icon>
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon">
                      filter_alt
                    </mat-icon>
                    <ng-container *ngIf="getFieldFilters$(col.field) | async as filters">
                      <span *ngIf="filters" class="clear-header-filters">({{ filters.length }})</span>
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
                <ng-container *ngIf="col.field == 'remarks'">
                  <button
                    class="clear-button"
                    mat-flat-button
                    color="warm"
                    (click)="clearAllFilter()"
                    *ngIf="extendedFilterActive$ | async"
                  >
                    clear all
                  </button>
                </ng-container>
              </div>
            </th>
            <th class="col--actions">
              <div class="clear-button">
                <button
                class="clear-button"
                mat-flat-button
                color="warn"
                (click)="clearAllFilter()"
                *ngIf="extendedFilterActive$ | async"
              >
                clear all
              </button>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <tr>
            <td class="col--type">{{ item.typeText }}</td>
            <td class="col--version">{{ item.version }}</td>
            <td class="col--language">{{ item.languageText }}</td>
            <td class="col--name">{{ item.templateName }}</td>
            <td class="col--owner">{{ item.networkOwner }}</td>
            <td class="col--template-description">{{ item.templateDescription }}</td>
            <td class="col--actions">
              <div class="chip-buttons">
                <input type="file" class="file-input" (change)="upload(item, $event)" accept=".docx" #fileUpload>
                <button class="chip clickable" (click)="fileUpload.click()" *ngIf="canWrite && !item.templateUrl">
                  <mat-icon>upload</mat-icon>
                </button>
                <button class="chip clickable" [disabled]="!item.templateUrl" (click)="download(item)">
                  <mat-icon class="material-icons-outlined">
                    download
                  </mat-icon>
                </button>
                <button class="chip clickable" (click)="delete(item)" *ngIf="canWrite">
                  <mat-icon class="material-icons-outlined">
                    delete
                  </mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
